var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomPolygon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33333 1.66667H11.6667M2.33333 12.3333H11.6667M12.3333 2.33333V11.6667M1.66667 2.33333V11.6667M11.6667 2.33333H13V1H11.6667V2.33333ZM6.33333 7.66667H7.66667V6.33333H6.33333V7.66667ZM1 2.33333H2.33333V1H1V2.33333ZM11.6667 13H13V11.6667H11.6667V13ZM1 13H2.33333V11.6667H1V13Z",
    stroke: "#1D1F2B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomPolygon);
export default __webpack_public_path__ + "static/media/custom-polygon.9317771ad0c874d359d8d334052f6213.svg";
export { ForwardRef as ReactComponent };